import React from 'react'
import { ModalWrapper } from 'src/components/modal-wrapper'
import { useStyles } from './styes'
import { useMediaQuery, useTheme } from '@mui/material'
import { useRedirectURLCreate } from 'src/hooks/redirect-urls/use-create-redirect-url.hook'
import { RedirectURLFromCreate } from './create-form'
import { Formik } from 'formik'
import { CreateActiveRedirectURLDto } from 'src/types/redirect-url.type'

interface IProps {
  modalOpen: boolean
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const RedirectURLModal = ({ modalOpen, setModalOpen }: IProps) => {
  const { mutate: create } = useRedirectURLCreate()
  const style = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const isProd = process.env.REACT_APP_STATUS_ENV === 'prod'
  // const env = isProd ? '' : 'dev.'
  const env2 = isProd ? '' : '-dev.'

  // const redirectTargetPrefix = `https://${env}app-v1.trackgood.io/`
  const redirectUrlPrefix = `https://app${env2}trackgood.io/?`

  const handleSubmit = async (values: CreateActiveRedirectURLDto) => {
    create(
      {
        redirect_url: values.redirect_url,
        redirect_target: values.redirect_target,
        note: values.note || null,
      },
      {
        onSuccess: (data) => {
          if (!data) {
            return
          }
          setModalOpen(false)
        },
        onError: () => setModalOpen(false),
      },
    )
  }

  return (
    <ModalWrapper
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      className={isTablet ? style.ownerInputModalTablet : style.ownerInputModal}
    >
      <Formik
        initialValues={{
          redirect_target: '',
          redirect_url: redirectUrlPrefix,
          active: false,
          note: '',
        }}
        onSubmit={handleSubmit}
      >
        <RedirectURLFromCreate isTablet={isTablet} />
      </Formik>
    </ModalWrapper>
  )
}
